



















import { Vue, Component, Prop } from 'vue-property-decorator';

import { Typography, Surface } from '@/components/atoms';

@Component({
  components: {
    Typography,
    Surface
  }
})
export default class SuggestionItemWarningApiToken extends Vue {
  @Prop({ default: () => ({}) })
  suggestion!: {
    title: string;
    description: string;
  };
}
